(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-manuals-home"] && !Shopify.designMode) return;
  try {
    
function setupPetFilters(root) {
  root.querySelectorAll('[data-pet-filter]').forEach(button => {
    if (button.dataset.petBound) return;
    button.dataset.petBound = 'true';
    button.addEventListener('click', () => {
      const scope = button.closest('.pets-home');
      const filter = button.dataset.petFilter;
      scope.querySelectorAll('[data-pet-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      scope.querySelectorAll('[data-pet-category]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.petCategory !== filter; });
    });
  });
}
setupPetFilters(document);
document.addEventListener('shopify:section:load', event => setupPetFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
